import cx from 'classnames';
import type { ChangeEventHandler, ReactNode } from 'react';
import { useState } from 'react';
import { RadioBehaviour } from '../../utils/RadioBehaviour';
import styles from './styles.module.css';

export interface RadioButtonProps {
  children: NonNullable<ReactNode>;
  id: string;
  name: string;
  value?: string;
  checked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  /** @deprecated Use onChange now */
  onClick?: never;
}

function RadioButton({ checked, children, onChange, onClick, value, name, id }: RadioButtonProps): ReactNode {
  const [hasFocus, setFocus] = useState(false);

  return (
    <RadioBehaviour
      value={value}
      name={name}
      id={id}
      checked={checked}
      className={cx(styles.RadioButtonContainer, {
        [styles.Checked]: !!checked,
        [styles.WithFocus]: hasFocus,
      })}
      onChange={onChange || onClick}
      onFocus={() => {
        setFocus(true);
      }}
      onBlur={() => {
        setFocus(false);
      }}
    >
      <div className={styles.RadioButton}>{children}</div>
    </RadioBehaviour>
  );
}

export interface RadioButtonGroupProps {
  stretch?: boolean;
  children: NonNullable<ReactNode>;
}

export function RadioButtonGroup({ stretch, children }: RadioButtonGroupProps): ReactNode {
  return <div className={cx({ [styles.Stretch]: stretch })}>{children}</div>;
}

RadioButtonGroup.RadioButton = RadioButton;
